import {
  Dialog,
  DialogContent,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { fontSizes } from "../constants/constants";
import icons from "../constants/icons";
import ViewReverse from "./ViewReverse";
import Text from "./Text";
import { ReactSVG } from "react-svg";
import { alertTabs } from "../config/config";
import CustomInput from "./CustomInput";
import CustomDropdown from "./CustomDropdown";
import CustomDatePicker from "./CustomDatePicker";
import Button from "./Button";
import AlertListView from "./AlertListView";
import { useDispatch, useSelector } from "react-redux";
import {
  createAlert,
  deleteAlert,
  editAlert,
  getAlertDropdown,
  getAlerts,
} from "../store/actions/alertAction";
import { Formik } from "formik";
import {
  alert_schema,
  alert_validation_schema,
} from "../validations_schemas/alert_validation_schema";
import { getContentKeyAccToLang } from "../utils/utils";
import dynamicfunction from "../utils/dynamicfunction";
import SuccessModal from "./SuccessModal";
import dayjs from "dayjs";
import CustomTabs from "./CustomTabs";
import { rowReverseStylesm } from "../utils/styles";

const AlertModal = ({ isOpen, onClose }) => {
  const { isArabic } = dynamicfunction();
  const dispatch = useDispatch();

  const { alerts, alertDropdowns, alertLoading, isAlertCall } = useSelector((state) => state.alert);
  const { settingContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      settingContent?.web_alert?.data?.attributes,
      key,
      isArabic
    );
  };

  const [isAddAlert, setIsAddAlert] = useState(false);
  const [selectedTab, setSelectedTab] = useState(alertTabs(getContentKey)?.[0]);
  const [editItem, setEditItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  // useEffect(() => {
  //   if (!isAlertCall) {
  //     dispatch(getAlerts());
  //   }
  //   dispatch(getAlertDropdown());
  // }, []);

  const handleChangeTab = (newValue) => {
    setSelectedTab(newValue);
    setIsAddAlert(false);
  };

  const onSaveAlert = (values, resetForm) => {
    const api_data = {
      symbolCode: values?.symbol_code,
      whereId: values?.where?.id,
      conditionId: values?.condition?.id,
      value: values?.value,
      expiryDate: values?.expiry_date,
    };
    isEditing
      ? dispatch(
          editAlert({ ...api_data, id: editItem?.id }, () => {
            dispatch(getAlerts());
            setIsAddAlert(false);
            resetForm();
          })
        )
      : dispatch(
          createAlert(api_data, () => {
            dispatch(getAlerts());
            resetForm();
            setIsAddAlert(false);
            setSuccessModal(true);
          })
        );
  };

  const handleDeleteAlert = (id) => {
    dispatch(deleteAlert({ id }));
  };

  const getAlertList = () => {
    switch (selectedTab?.id) {
      case 0:
        return alerts?.filter((item) => item?.statusMappingId == 1);
      case 1:
        return alerts?.filter((item) => item?.statusMappingId == 2);
      case 2:
        return alerts?.filter((item) => item?.statusMappingId == 3);
    }
  };

  const handleClose = () => {
    setIsAddAlert(false);
    setIsEditing(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={"md"}>
      <DialogContent>
        <ViewReverse className={"w-full justify-between my-4"}>
          <Text
            text={getContentKey("alert")}
            size={fontSizes.h20}
            color="text-primary"
          />
          <ReactSVG
            src={icons.modalCross}
            onClick={handleClose}
            className="cursor-pointer opacity-50"
          />
        </ViewReverse>

        <ViewReverse className="items-center w-full justify-between border-b-2 border-b-grey gap-4">
          <div className="-mb-[2px] w-[85%] sm:w-[90%]">
            <CustomTabs
              selectedTab={selectedTab}
              data={alertTabs(getContentKey)}
              onPress={handleChangeTab}
              isBottomBorder={false}
            />
          </div>

          <ReactSVG
            src={icons.plusSelected}
            className="cursor-pointer"
            onClick={() => setIsAddAlert(true)}
          />
        </ViewReverse>

        {isAddAlert ? (
          <Formik
            validationSchema={alert_validation_schema}
            initialValues={editItem || alert_schema}
            validateOnChange={false}
            validateOnMount={false}
            validateOnBlur={false}
            onSubmit={(values, functions) =>
              onSaveAlert(values, functions?.resetForm)
            }
            className="w-full"
          >
            {({
              handleSubmit,
              setFieldValue,
              setFieldError,
              values,
              errors,
              resetForm,
            }) => {
              return (
                <div className="py-6">

                  <ViewReverse className={`gap-4 flex-col ${rowReverseStylesm(isArabic)}`}>
                    <CustomDropdown
                      label={getContentKey("symbol_index")}
                      options={alertDropdowns?.symbolList}
                      onSelect={(item) => {
                        setFieldValue("symbol_name", item?.name);
                        setFieldValue("symbol_code", item?.code);
                      }}
                      selectedValue={
                        values?.symbol_name
                          ? `${values?.symbol_name} - ${values?.symbol_code}`
                          : null
                      }
                      placeholder={getContentKey("enter_symbol_index")}
                      isSymbol
                      isSearch
                    />

                    <CustomDropdown
                      label={getContentKey("where")}
                      selectedValue={values?.where}
                      options={alertDropdowns?.whereList}
                      onSelect={(val) => setFieldValue("where", val)}
                    />
                  </ViewReverse>

                  <ViewReverse className={`gap-4 flex-col mt-6 ${rowReverseStylesm(isArabic)}`}>
                    <CustomDropdown
                      label={getContentKey("condition")}
                      placeholder={getContentKey("greater_than_equal")}
                      selectedValue={values?.condition}
                      options={alertDropdowns?.conditionList}
                      onSelect={(val) => setFieldValue("condition", val)}
                    />
                    <CustomInput
                      label={getContentKey("value")}
                      placeholder={getContentKey("enter_alert_value")}
                      value={values?.value}
                      onChange={(e) => setFieldValue("value", e.target.value)}
                      isFullborder
                      isRounded
                      type="number"
                    />
                  </ViewReverse>

                  <ViewReverse className={`gap-4 flex-col mt-6 ${rowReverseStylesm(isArabic)}`}>
                    <CustomDatePicker
                      label={getContentKey("expiry_date")}
                      placeholder={"mm/dd/yyyy"}
                      width="w-full sm:w-1/2"
                      selectedDate={
                        values?.expiry_date !== "" ? values?.expiry_date : null
                      }
                      onChange={(e) => setFieldValue("expiry_date", e?.$d)}
                      minDate={dayjs()}
                    />
                    <div className="hidden sm:block w-1/2" />
                  </ViewReverse>

                  <ViewReverse
                    className={
                      "items-center justify-end rounded pt-4 sm:px-8 bg-white gap-4"
                    }
                  >
                    <Button
                      text={getContentKey("save")}
                      bgColor="bg-primary"
                      className={"border border-orange text-center w-full sm:w-32 px-0"}
                      onClick={handleSubmit}
                      loading={alertLoading}
                    />
                    <Button
                      text={getContentKey("cancel")}
                      bgColor="bg-white"
                      color={"text-primary"}
                      className={
                        "text-center w-full sm:w-32 px-0 border border-primary"
                      }
                      onClick={() => {
                        resetForm();
                        setIsAddAlert(false);
                        setEditItem(null);
                      }}
                    />
                  </ViewReverse>
                </div>
              );
            }}
          </Formik>
        ) : (
          <div className="w-full min-h-96 max-h-96 overflow-y-scroll">
            {getAlertList()?.length > 0 ? (
              getAlertList()?.map((item) => (
                <AlertListView
                  key={item?.id}
                  symbol={item?.symbol}
                  symbolCode={item?.symbolCode}
                  condition={item?.condition}
                  value={item?.value}
                  expiryDate={item?.expiryDate}
                  handleDelete={() => handleDeleteAlert(item?.id)}
                  statusId={item?.statusMappingId}
                  handleModify={() => {
                    setEditItem({
                      id: item?.id,
                      value: item?.value,
                      symbol_code: item?.symbolCode,
                      symbol_name: item?.symbol,
                      where: {
                        id: item?.whereId,
                        name: item?.where,
                      },
                      condition: {
                        id: item?.conditionId,
                        name: item?.condition,
                      },
                      expiry_date: new Date(item?.expiryDate),
                    });
                    setIsAddAlert(true);
                    setIsEditing(true);
                  }}
                />
              ))
            ) : (
              <Text
                text="No results"
                className={"text-center text-opacity-50 mt-4"}
              />
            )}
          </div>
        )}
      </DialogContent>

      <SuccessModal
        open={successModal}
        onClose={() => setSuccessModal(false)}
        title={"Alert Added Successfuly"}
      />
    </Dialog>
  );
};

export default AlertModal;
